import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/Button';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function CheckoutBasicCancel() {
    const navigate = useNavigate();
    const { t } = useTranslation('checkout');

    return (
        <>
            <Helmet>
                <title>{t('cancel.title')}</title>
            </Helmet>
            <div className="flex flex-col items-center justify-center h-screen py-10 px-4 gap-20">
                <h1 className="text-2xl lg:text-4xl text-center font-bold leading-[1.8] tracking-widest mt-4">
                    {t('cancel.title')}
                </h1>
                <div className="flex flex-col items-center justify-center gap-4">
                    <p className="text-lg leading-[1.8] tracking-widest">{t('cancel.lead')}</p>
                    <p className="text-center leading-[1.8] tracking-widest text-gray-700">
                        {t('cancel.description')}
                    </p>
                </div>
                <div className="flex flex-col items-center justify-center gap-8">
                    <Button
                        onClick={() => navigate('/plans')}
                        className="h-16 w-52 text-lg"
                        variant="original"
                    >
                        {t('cancel.ctaPlans')}
                    </Button>
                    <Link
                        to="/desk"
                        className="leading-[1.8] tracking-widest underline text-blue-600"
                    >
                        {t('cancel.ctaDesk')}
                    </Link>
                </div>
            </div>
        </>
    );
}

export default CheckoutBasicCancel;
